var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"player-area"},[_c('video',{ref:"vid2",staticClass:"video-js",attrs:{"id":"vid1","width":"480","height":"270","controls":""}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }